<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 予約施設：特別営業日詳細（追加・編集）の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

  <mat-card appearance="outlined" class="manual-card">
    <mat-card-header>
      <mat-card-title><span>予約施設：特別営業日詳細（追加・編集）の説明</span></mat-card-title>
    </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/reservation-facility-special-dialog.png" width="100%">
        </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/B.png"> 営業日種別
      </div>
      <div class="manual-explain">
        営業日種別を選択します。休日／特別営業日のいずれかを選択します。<br>
        「休日」を選択した場合･･･営業期間（赤枠C）の設定期間の予約を不可とします。また、最大予約数（赤枠E）と時間枠（赤枠D）は非表示となります。<br>
        「特別営業日」を選択した場合･･･<br>
        &nbsp;&nbsp;&nbsp;&nbsp;かつ予約施設の予約方式が「日付（期間）」の場合･･･最大予約数（赤枠E）が表示され、営業期間（赤枠C）の間は、こちらで登録した予約数分の予約を可能とします。<br>
        &nbsp;&nbsp;&nbsp;&nbsp;かつ予約施設の予約方式が「時間枠」の場合･･･時間枠（赤枠D）が表示され、営業期間（赤枠C）の間は、こちらで登録した時間枠単位での予約を可能とします。<br>
        <span class="manual-explain-notes">※必須項目</span>
      </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> 営業日種別
        </div>
        <div class="manual-explain">
          営業日種別を選択します。休日／特別営業日のいずれかを選択します。<br>
          「休日」を選択した場合･･･営業期間（赤枠C）の設定期間の予約を不可とします。また、最大予約数（赤枠D）と時間枠（赤枠E）は非表示となります。<br>
          「特別営業日」を選択した場合･･･<br>
          &nbsp;&nbsp;&nbsp;&nbsp;かつ予約施設の予約方式が「日付（期間）」の場合･･･最大予約数（赤枠D）が表示され、営業期間（赤枠C）の間は、こちらで登録した予約数分の予約を可能とします。<br>
          &nbsp;&nbsp;&nbsp;&nbsp;かつ予約施設の予約方式が「時間枠」の場合･･･時間枠（赤枠E）が表示され、営業期間（赤枠C）の間は、こちらで登録した時間枠単位での予約を可能とします。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/D.png"> 時間枠
      </div>
      <div class="manual-explain">
        1日の中で予約可能な時間枠を設定します。<br>
        予約施設の予約方式が「時間枠」、かつ営業日種別（赤枠B）で「特別営業日」を選択した場合に表示されます。<br>
        <span class="manual-explain-notes">※必須項目</span>
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/E.png"> 最大予約数
      </div>
      <div class="manual-explain">
        最大予約数を設定します。<br>
        予約施設の予約方式が「日付（期間）」、かつ営業日種別（赤枠B）で「特別営業日」を選択した場合に表示されます。<br>
        <span class="manual-explain-notes">※必須項目</span>
      </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> 時間枠
        </div>
        <div class="manual-explain">
          1日の中で予約可能な時間枠を設定します。<br>
          予約施設の予約方式が「時間枠」、かつ営業日種別（赤枠B）で「特別営業日」を選択した場合に表示されます。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> 更新ボタン
        </div>
        <div class="manual-explain">
          クリックすることで編集内容が更新されます。
        </div>

      </mat-card-content>
    </mat-card>
  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Home</a> » Reservation Facility: Special Operating Days (Add/Edit) Description
  </div>
  
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
  
    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Reservation Facility: Special Operating Days (Add/Edit) Description</span></mat-card-title>
      </mat-card-header>
  
      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_reservation-facility-special-dialog.png" width="100%">
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Close Button
        </div>
        <div class="manual-explain">
          Clicking this button closes the dialog.<br>
          Any changes made will not be saved.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Operating Day Type
        </div>
        <div class="manual-explain">
          Select the type of operating day. Choose either Holiday or Special Operating Day.<br>
          If "Holiday" is selected: Reservations will not be allowed for the specified operating period (red box C). Maximum Reservations (red box D) and Time Slots (red box E) will be hidden.<br>
          If "Special Operating Day" is selected:<br>
          &nbsp;&nbsp;&nbsp;&nbsp;- For facilities with a reservation method of "Date (Period)": Maximum Reservations (red box D) will appear, and reservations will be allowed for the specified operating period (red box C) up to the registered maximum.<br>
          &nbsp;&nbsp;&nbsp;&nbsp;- For facilities with a reservation method of "Time Slot": Time Slots (red box E) will appear, and reservations will be allowed for the specified operating period (red box C) based on the registered time slots.<br>
          <span class="manual-explain-notes">* Required field</span>
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Operating Period
        </div>
        <div class="manual-explain">
          Set the operating period.<br>
          * For a single day, enter only the start date.<br>
          <span class="manual-explain-notes">* Start date is required</span>
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Maximum Reservations
        </div>
        <div class="manual-explain">
          Set the maximum number of reservations.<br>
          This field is displayed when the reservation method is "Date (Period)" and the operating day type (red box B) is set to "Special Operating Day."<br>
          <span class="manual-explain-notes">* Required field</span>
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> Time Slots
        </div>
        <div class="manual-explain">
          Set the available time slots for reservations within a day.<br>
          This field is displayed when the reservation method is "Time Slot" and the operating day type (red box B) is set to "Special Operating Day."<br>
          <span class="manual-explain-notes">* Required field</span>
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> Update Button
        </div>
        <div class="manual-explain">
          Clicking this button saves the edited content.
        </div>
  
      </mat-card-content>
    </mat-card>
  
  </div>
</div>